import { toGregorian } from "jalaali-js";
import { PersianDayValue } from "../components/common/PersianDatePicker";

export const toGregorianIsoDate = (value: PersianDayValue) => {
  if (!value) return "";

  const gregorianDate = toGregorian(value.year, value.month, value.day);

  return [
    gregorianDate.gy,
    String(gregorianDate.gm).padStart(2, "0"),
    String(gregorianDate.gd).padStart(2, "0"),
  ].join("-");
};

export const toPersianDayValue = (
  value?: string | Date | null,
): PersianDayValue => {
  if (!value) return null;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const formatter = new Intl.DateTimeFormat("en-US-u-ca-persian-nu-latn", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  const parts = formatter.formatToParts(date);

  return {
    year: Number(parts.find((part) => part.type === "year")?.value),
    month: Number(parts.find((part) => part.type === "month")?.value),
    day: Number(parts.find((part) => part.type === "day")?.value),
  };
};

export const formatPersianDayValue = (value: PersianDayValue) => {
  if (!value) return "—";
  return `${value.year}/${value.month}/${value.day}`;
};

export const getTodayPersianDay = (): NonNullable<PersianDayValue> => {
  const formatter = new Intl.DateTimeFormat("en-US-u-ca-persian-nu-latn", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  const parts = formatter.formatToParts(new Date());

  return {
    year: Number(parts.find((part) => part.type === "year")?.value),
    month: Number(parts.find((part) => part.type === "month")?.value),
    day: Number(parts.find((part) => part.type === "day")?.value),
  };
};
